const userAgent = window.navigator.userAgent;
const ua = userAgent.toLowerCase();
const platform = {
  isAndroid: function () {
    return ua.indexOf('android') > -1;
  },
  isIOS: function () {
    return ua.indexOf('iphone') > -1;
  },
  isWinPhone: function () {
    return !!navigator.userAgent.match(/Windows Phone/i);
  },
  isIpad: function () {
    var NPlatform = navigator.platform;
    return (
      /iPad/gi.test(NPlatform) ||
      (NPlatform === 'MacIntel' &&
        navigator.maxTouchPoints > 1 &&
        !window.MSStream)
    );
  },
  isPhone: function () {
    return (
      this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
    );
  },
  isIE11: function () {
    return (
      userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    );
  },
  isEdge: function () {
    return userAgent.indexOf('Edge') > -1;
  },
};

export const whatDevice = () => {
  if (!platform.isPhone() || platform.isIE11() || platform.isEdge()) {
    return 'pc';
  }
  if (platform.isPhone()) {
    return 'mobile';
  }
};

export const isIE = () => {
  return platform.isIE11();
};

export const deviceType = () => {
  if (platform.isIOS() || platform.isIpad()) {
    return 'ios';
  }
  if (platform.isAndroid()) {
    return 'android';
  }
};

export const getTime = () => {
  const startTime = Math.ceil(new Date().getTime() / 1000); //单位秒
  const getDuration = () => {
    let time = '',
      hours = 0,
      minutes = 0,
      seconds = 0,
      endTime = Math.ceil(new Date().getTime() / 1000),
      duration = endTime - startTime;

    hours = Math.floor(duration / 3600); //停留小时数
    minutes = Math.floor((duration % 3600) / 60); //停留分钟数
    seconds = Math.floor((duration % 3600) % 60); //停留秒数

    time =
      (hours < 10 ? '0' + hours : hours) +
      ':' +
      (minutes < 10 ? '0' + minutes : minutes) +
      ':' +
      (seconds < 10 ? '0' + seconds : seconds);

    return time;
  };

  window.addEventListener('beforeunload', () => {
    const duration = getDuration();
    // localStorage.setItem('time', duration);
  });
};

export const login = () => {
  const forward = encodeURIComponent(window.location.href);
  window.open(
    `https://gabres.blancozone.com/platform/login.html?forward=${forward}&gameId=251`,
    '_self'
  );
};

// 防抖
export const debounce = (cb, delay = 300) => {
  let timer = 0;

  return function () {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      cb.apply(this, arguments);
      timer = 0;
    }, delay);
  };
};

// 节流
export const throttle = (cb, delay = 300) => {
  let timer = 0;

  return function () {
    if (timer) return;
    timer = setTimeout(() => {
      cb.apply(this, arguments);
      timer = 0;
    }, delay);
  };
};

export const computeEleLocation = $el => {
  let scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
  let top = $el.getBoundingClientRect().top;
  return scrollHeight + top;
};

export const computeEleShow = $el => {
  let scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
  let innerHeight = window.innerHeight;
  let { top, height } = $el.getBoundingClientRect();
  let a = scrollHeight + top + (height / 2 - 1);
  let b = scrollHeight + top + (height - height / 2 + 1);
  let bool = scrollHeight + innerHeight > a && scrollHeight < b;
  return bool;
};

export const isInViewPortOfOne = el => {
  const viewPortHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  const offsetTop = el.offsetTop;
  const scrollTop = document.documentElement.scrollTop;
  const top = offsetTop - scrollTop;
  return top + 50 <= viewPortHeight;
};
